<template>
    <router-link :to="allowNavigation ? `/account/shop/${item.productId}` : ''" @click.native="productClicked(item)">
        <div class="shop__product-block__image-container">
            <img class="shop__product-block__image-hover-state" :src="item.images.main.thumbnail"/>
            <img class="shop__product-block__image" :src="item.images.gallery[0].thumbnail" />
        </div>
        <p v-if="!hideTitle" class="shop__product-block__text shop__small-paragraph" v-text="item.title"></p>
        <div class="shop__product-block__Price-container">
            <p v-if="!hidePrice && showOfferPrice" class="shop__product-block__Price-container__text shop__small-paragraph" :class="{'shop__product-block__offerPrice': showOfferPrice}" v-text="`${currency}${item.old_price}`"></p>
            <p v-if="!hidePrice" class="shop__product-block__Price-container__text offer shop__small-paragraph" v-text="displayPrice"></p>
        </div>
    </router-link>
</template>

<script>
import countriesJson from '@/resources/countries.json';

export default {
    name: 'ProductCard',
    props: {
        allowNavigation: {
            required: false,
            type: Boolean,
            default: true,
        },
        item: {
            required: true,
            type: Object,
        },
        hideTitle: {
            required: false,
            type: Boolean,
        },
        hidePrice: {
            required: false,
            type: Boolean,
        },
    },
    computed: {
        currency() {
            const country = countriesJson.find(country => country.currency.code === this.item.currency);
            return country.currency.symbol;
        },
        displayPrice() {
            let fract = this.item.price.split('.')[1];
            const price = Number(fract) > 0 ? this.item.price : Number(this.item.price);
            return `${this.currency}${price}`;
        },
        showOfferPrice() {
            return Number(this.item.old_price) > 0;
        },
    },
    methods: {
        productClicked(item) {
            this.$emit('product-clicked', item);
        },
    },
};
</script>
